/**
 * Web shim for react-native-sound
 * Uses Web Audio API where available, otherwise no-op.
 */

class Sound {
  private audio: HTMLAudioElement | null = null;
  
  static setCategory(_category: string) {}
  
  constructor(filename: string, _basePath: string, onLoad?: (error: any) => void) {
    try {
      this.audio = new Audio(filename);
      this.audio.oncanplaythrough = () => onLoad?.(null);
      this.audio.onerror = () => onLoad?.(new Error('Failed to load audio'));
    } catch (e) {
      onLoad?.(e);
    }
  }
  
  play(onEnd?: (success: boolean) => void) {
    if (this.audio) {
      this.audio.play()
        .then(() => {
          if (this.audio) {
            this.audio.onended = () => onEnd?.(true);
          }
        })
        .catch(() => onEnd?.(false));
    } else {
      onEnd?.(false);
    }
  }
  
  stop() {
    if (this.audio) {
      this.audio.pause();
      this.audio.currentTime = 0;
    }
  }
  
  release() {
    if (this.audio) {
      this.audio.src = '';
      this.audio = null;
    }
  }
  
  getCurrentTime(callback: (seconds: number) => void) {
    callback(this.audio?.currentTime || 0);
  }
  
  setCurrentTime(seconds: number) {
    if (this.audio) {
      this.audio.currentTime = seconds;
    }
  }
}

export default Sound;
